import React from 'react';

import DoneIcon from '@material-ui/icons/Done';

const confirmedStyle = {
    color : "green"
};

export default function DenyButton(props)
{
  return {
      color : "inherit",
      style : confirmedStyle,
      label : props.name,
      "aria-label" : props.name + "の状態を解除",
      icon : <DoneIcon />,
      ...props
  }
}